import { Grid, withWidth, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { Stack } from 'office-ui-fabric-react';
import Benefit1 from "../../../../../assert/images/benefit1.png";
import Benefit2 from "../../../../../assert/images/benefit2.png";
import Benefit3 from "../../../../../assert/images/benefit3.png";
import Benefit4 from "../../../../../assert/images/benefit4.png";
import Benefit5 from "../../../../../assert/images/benefit5.png";
import Benefit6 from "../../../../../assert/images/benefit6.png";
import BenefitBg from "../../../../../assert/images/benefitbg.png";


function Benefits(props) {

    let [width, setWidth] = React.useState(window.innerWidth);
   
    let updateWidthAndHeight = () => {
        setWidth(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", updateWidthAndHeight);
        return () => window.removeEventListener("resize", updateWidthAndHeight);
    });
    const benefitItems = [
        { id: 1, icon: Benefit1, des: "Shave days-to-weeks off procurement and deployment time, and fast track directly to testing and validation", title: "Eliminate IT lead time" },
        { id:2, icon: Benefit4, des: "Make a sustainable choice by knowing the Carbon footprint of your cloud use, and adopting a platform that is tracking aggressively towards net-zero", title: "Carbon reduced" },
        { id:3, icon: Benefit2, des: "Have off hours-to-days by bypassing queues, so that quality time equates to run time", title: "Eliminate application wait time" },
        { id:4, icon: Benefit3, des: "Exploit frequent refresh cycles without obligation, rather than being locked into 3–5-year purchases", title: "Evergreen hardware" },
        { id:5, icon: Benefit5, des: "Run your application at scale, even if that means Top500-class supercomputers", title: "Scale without constraints" },
        { id:6, icon: Benefit6, des: "Rapidly prototype by tapping a broad and deep HPC ecosystem that includes AI", title: "Innovate without bounds" },
        { id:7, icon: Benefit6, des: "Enlist resources as pay-pay-use OpEx expenditures and/or fixed-term CapEx assets", title: "Aligned with fiscal preferences" },
        { id:8, icon: Benefit6, des: "Augment your on-premises HPC infrastructure with offerings available from the cloud", title: "Implement a hybrid cloud" },
    ]

    return (
        <React.Fragment>
            <div style={{ backgroundColor: "#fff", padding: props.width === 'xs' || props.width === 'sm' ?"40px 40px 0px 50px" : "80px 40px 0px 50px" }} ref={props.benefitRef}>
                <Grid container direction="row" spacing={props.width === 'xs' || props.width === 'sm' ? 5 : 10} justifyContent="center" alignItems="center">
                    <Grid item xs={9} sm={10} md={12} style={{textAlign:"center"}} >
                        <Typography style={{ fontWeight: 800, fontSize: props.width === 'xs' || props.width === 'sm' ? 32 : "2.3vw", color: "#502eff" }}>Benefits</Typography>
                       
                    </Grid>
                    {
                        props.width === 'xs' || props.width === 'sm' ?
                            <Grid item xs={3} sm={2} md={2} >
                                <img src={BenefitBg} alt="Benefit" width="150%" height="50%" />
                            </Grid> : <></>
                    }
                    <Grid item xs={12} sm={12} md={10} style={{ paddingLeft: props.width === 'xs' || props.width === 'sm'? 20 : 60}}>
                        <Grid container direction="row" spacing={10} style={{ alignItems: "center" }}>
                            {
                                benefitItems.map(data => {
                                    return (
                                        <Grid key={data.id} item xs={12} sm={12} md={6} style={{paddingTop:50}}>
                                            <Grid container direction="row" style={{ alignItems: "center" }}>
                                                <Grid item xs={2} sm={2} md={2} >
                                                    <img src={data.icon} alt="Benefit1" width={props.width === "xs" ? "84%" : "50%"} height="86%"/>
                                                </Grid>
                                                <Grid item xs={10} sm={10} md={10}>
                                                    <Typography style={{ fontWeight: 800, paddingLeft: 20, fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.2vw", color: "rgb(80, 46, 255)"}}>{data.title}</Typography>
                                                    <Typography style={{ fontWeight: 450, paddingLeft: 20, fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.2vw"}}>{data.des}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                    
                                })

                            }
                        </Grid>
                    </Grid>
                    {
                        props.width !== 'xs' && props.width !== 'sm' ?
                        <Grid item xs={12} sm={12} md={2} style={{ paddingLeft: 50, paddingTop: -50 }} >
                            <img src={BenefitBg} alt="Benefit" width="150%" height="100%" />
                        </Grid> :<></>
                    }
                </Grid>
            </div>
            <div className="indOurMis">
                <div className="iomInner">
                        <Grid container direction="row" >
                            <Grid item md={12}>
                                <Typography style={{ color: "#cedaf8", fontSize:  props.width === 'xs' || props.width === 'sm' ? 32 : "2.3vw", fontWeight: 500 }}>OUR MISSION</Typography>
                            </Grid>
                            <Grid item md={12} style={{marginTop: 10}}>
                                <div style={{ marginTop: 10, height: props.width === 'xs' || props.width === 'sm' ? 1 : 1, backgroundColor: "#fff" }}></div>
                               
                            </Grid>
                           
                            <Grid item md={12} style={{ marginTop: 20 }}>
                                <Typography style={{
                                    color: "#f1f1f1", fontSize: props.width === 'xs' || props.width === 'sm' ? 14 : "1.3vw"
                                }}>Empower researchers with simplified access to cloud workspaces, enhancing the versatility and reproducibility of their workflows, while accelerating results and reducing costs.</Typography>
                            </Grid>
                            <Grid item md={6}>
                               
                            </Grid>
                        </Grid>
                    </div>
            </div>


        </React.Fragment>
    );
}

export default withWidth()(Benefits);